import { getRouteStackPath } from '@portal/config/routes';
import { PageClass } from '@portal/enum/analytics';
import { sendEvent } from '@portal/services/firebase';
import { Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { translate } from '~/services/i18n';

import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import { useNavigation } from '@portal/hooks/useNavigation';
import Icon from '../../assets/svg/ic_404.svg';

const NotFound: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigation();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.NOT_FOUND,
    });

    if (
      window.location.pathname ===
      getRouteStackPath('PROFILE', 'ACCOUNT_SELECTION')
    ) {
      navigate('/');
    }
  }, [location]);

  return (
    <div className="not-found">
      <div className="not-found__inner">
        <Row className="justify-content-center">
          <Col md={12}>
            <div className="not-found__inner__icon">
              <img
                className="not-found__inner__icon__img"
                src={Icon}
                alt="404 icon"
              />
            </div>
            <h3 className="not-found__inner__title">
              {translate('PAGES.NOT_FOUND.TITLE')}
            </h3>
            <p className="not-found__inner__desc">
              {translate('PAGES.NOT_FOUND.PAGE_DESCRIPTION')}
            </p>
            <AdvancedButton
              text={translate('PAGES.NOT_FOUND.BUTTON_TEXT')}
              onClick={() => navigate('/')}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default NotFound;
